/**
 *  LANGUAGE FILE FOR ENGLISH
 */

export default {
  title: "Demo Truck. v1.0",
  nav: {
    home: "Home",
    about: "About",
    contact: "Contact"
  },
  search: {
    placeholder: "Search Artists..."
  },
  events: {
    country: "Country",
    city: "City",
    venue: "Venue",
    date: "Date",
    "upcomming-events": "Upcoming Albums",
    play_count: "Play Counts"
  }
};
